export default "https://fenwan.cdn.bcebos.com/gamecenter/static/game/assets/imgs/download-icon2.c408e23d.png";